import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import ArticuloService from "features/Inventario/services/ArticuloService"
import mapArticulosByCategoria from "features/Inventario/utils/mapArticulos"

export const getArticulosGroupedByCategoria = createAsyncThunk(
  "articulos/getArticulosGroupedByCategoria",
  async ({
    // @ts-expect-error TS(2339): Property 'catalogoId' does not exist on type 'void...
    catalogoId,
    // @ts-expect-error TS(2339): Property 'concepto' does not exist on type 'void'.
    concepto,
    // @ts-expect-error TS(2339): Property 'precioVentaLowerLimit' does not exist on...
    precioVentaLowerLimit,
    // @ts-expect-error TS(2339): Property 'precioVentaUpperLimit' does not exist on...
    precioVentaUpperLimit,
    // @ts-expect-error TS(2339): Property 'categoriasId' does not exist on type 'vo...
    categoriasId,
  }) => {
    const { data } = await ArticuloService.getArticulosGroupedByCategoria({
      catalogoId,
      concepto,
      precioVentaLowerLimit,
      precioVentaUpperLimit,
      categoriasId,
    })

    return data
  }
)

export const getArticulosByCatalogoIdEncrypted = createAsyncThunk(
  "articulos/getArticulosByCatalogoIdEncrypted",
  async ({
    // @ts-expect-error TS(2339): Property 'catalogoId' does not exist on type 'void...
    catalogoId,
    // @ts-expect-error TS(2339): Property 'concepto' does not exist on type 'void'.
    concepto,
    // @ts-expect-error TS(2339): Property 'precioVentaLowerLimit' does not exist on...
    precioVentaLowerLimit,
    // @ts-expect-error TS(2339): Property 'precioVentaUpperLimit' does not exist on...
    precioVentaUpperLimit,
    // @ts-expect-error TS(2339): Property 'categoriasId' does not exist on type 'vo...
    categoriasId,
  }) => {
    const { data } = await ArticuloService.getArticulosByCatalogoIdEncrypted({
      catalogoId,
      concepto,
      precioVentaLowerLimit,
      precioVentaUpperLimit,
      categoriasId,
    })

    return data
  }
)

const initialState = {
  articulosGroupedByCategoria: {},
  fetchingArticulos: true,
  searchArticuloName: "",
}

export const articulosSlice = createSlice({
  name: "articulos",
  initialState,
  reducers: {
    setSearchArticuloName(state, { payload }) {
      state.searchArticuloName = payload
    },
    clearArticuloState() {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getArticulosGroupedByCategoria.pending, (state) => {
        state.fetchingArticulos = true
      })
      .addCase(getArticulosGroupedByCategoria.rejected, (state) => {
        state.fetchingArticulos = false
      })
      .addCase(
        getArticulosGroupedByCategoria.fulfilled,
        (state, { payload }) => {
          state.fetchingArticulos = false
          state.articulosGroupedByCategoria = mapArticulosByCategoria(payload)
        }
      )
      .addCase(getArticulosByCatalogoIdEncrypted.pending, (state) => {
        state.fetchingArticulos = true
      })
      .addCase(getArticulosByCatalogoIdEncrypted.rejected, (state) => {
        state.fetchingArticulos = false
      })
      .addCase(
        getArticulosByCatalogoIdEncrypted.fulfilled,
        (state, { payload }) => {
          state.fetchingArticulos = false
          state.articulosGroupedByCategoria = mapArticulosByCategoria(payload)
        }
      )
  },
})

export const { setSearchArticuloName, clearArticuloState } =
  articulosSlice.actions
